{
  "title": "Suppliers",
  "subtitle": "The companies and people you buy from: what you received from them, what you paid, what you still owe.",
  "inactive": "Inactive",
  "list": {
    "new": "New supplier",
    "search": "Name, number, phone or tax ID",
    "statusLabel": "Status",
    "status": {
      "active": "Active",
      "inactive": "Inactive",
      "all": "All suppliers"
    },
    "owed": "Still owed money",
    "sort": "Sort",
    "sorts": {
      "name_asc": "Name, A to Z",
      "name_desc": "Name, Z to A",
      "balance_desc": "Largest balance first",
      "createdAt_desc": "Newest first"
    },
    "clear": "Clear filters",
    "showing_one": "{{first}} to {{last}} of {{total}} supplier",
    "showing_other": "{{first}} to {{last}} of {{total}}"
  },
  "empty": {
    "title": "No supplier yet",
    "text": "Add the suppliers you buy from here, or save them while you receive their goods."
  },
  "noMatch": {
    "title": "No supplier found",
    "text": "Try another name, number or phone, or show the inactive suppliers too."
  },
  "columns": {
    "supplier": "Supplier",
    "balance": "Balance",
    "open": "Open receipts",
    "receipt": "Receipt",
    "date": "Date",
    "theirReference": "Their reference",
    "status": "Status",
    "payment": "Payment",
    "pays": "Pays",
    "allocated": "Amount"
  },
  "fields": {
    "name": "Name",
    "contactName": "Contact person",
    "phone": "Phone",
    "email": "Email",
    "address": "Address",
    "city": "City",
    "taxId": "Tax ID",
    "notes": "Notes"
  },
  "form": {
    "newTitle": "New supplier",
    "newHint": "Only the name is needed; the rest can come later.",
    "editTitle": "Edit {{number}}",
    "create": "Add the supplier",
    "created": "Supplier {{number}} added",
    "saved": "Supplier saved",
    "taxIdHint": "Matricule fiscal",
    "notesHint": "Payment terms, opening hours, anything the team should know."
  },
  "details": {
    "created": "Added",
    "updated": "Last changed"
  },
  "actions": {
    "edit": "Edit",
    "pay": "Record a payment",
    "receive": "Receive stock",
    "deactivate": "Deactivate",
    "activate": "Activate",
    "deactivateTitle": "Deactivate this supplier?",
    "deactivateText": "It leaves the lists you pick suppliers from. Its receipts, payments and balance stay, and you can activate it again later.",
    "activateTitle": "Activate this supplier?",
    "activateText": "It can be picked again when goods are received.",
    "deactivated": "Supplier deactivated",
    "activated": "Supplier activated"
  },
  "figures": {
    "balance": "Balance",
    "openReceipts_zero": "Nothing left to pay on its receipts",
    "openReceipts_one": "{{count}} receipt not fully paid",
    "openReceipts_other": "{{count}} receipts not fully paid",
    "creditHint": "Paid in advance: the supplier owes you this.",
    "amountDue": "To pay",
    "receipts_zero": "No receipt yet",
    "receipts_one": "{{count}} receipt · goods {{value}}",
    "receipts_other": "{{count}} receipts · goods {{value}}",
    "paid": "Paid",
    "advance": "Of which {{amount}} not allocated yet",
    "scheduled": "Scheduled",
    "scheduledHint": "Cheques, bills and credits not settled yet."
  },
  "tabs": {
    "receipts": "Receipts",
    "payments": "Payments",
    "statement": "Statement",
    "details": "Details"
  },
  "receipts": {
    "empty": "No receipt from this supplier yet.",
    "scheduled": "{{amount}} scheduled"
  },
  "statement": {
    "empty": "Nothing received from or paid to this supplier yet.",
    "document": "Document",
    "due": "To pay"
  },
  "receiptStatus": {
    "unpaid": "Unpaid",
    "partlyPaid": "Partly paid",
    "paid": "Paid"
  },
  "paymentStatus": {
    "pending": "Pending",
    "completed": "Paid",
    "cancelled": "Cancelled"
  },
  "picker": {
    "placeholder": "Search a supplier or type a name",
    "save": "Save “{{name}}” as a supplier",
    "typedOnly": "Typed only: no supplier is recorded unless you save it.",
    "unlink": "Remove {{name}}"
  },
  "receipt": {
    "title": "Payments",
    "afterValidation": "Record what you pay for this receipt once it is validated. Money paid in advance can be recorded on the supplier now.",
    "goodsValue": "Goods value",
    "amountDue": "Amount to pay",
    "isGoodsValue": "The goods value",
    "changeDue": "Change the amount to pay",
    "dueTitle": "Amount to pay the supplier",
    "dueHint": "The supplier's invoice total, with VAT, transport or stamp duty. The goods are worth {{amount}} in stock.",
    "useGoodsValue": "Use the goods value",
    "dueSaved": "Amount to pay saved",
    "open": "Still to pay",
    "noPayments": "No payment yet.",
    "advances": "Apply money already paid to this supplier"
  },
  "pay": {
    "title": "Record a payment",
    "noSupplier": "For a receipt from a supplier that is not registered",
    "method": "Method",
    "amount": "Amount",
    "date": "Date",
    "status": "Status",
    "completedNow": "Paid now",
    "pendingLater": "To settle later",
    "pendingHint": "It shows as scheduled and is not counted as paid until you mark it paid.",
    "deferredHint": "A credit is a promise to pay: it stays scheduled until it is paid, and you then say how.",
    "number": "Number",
    "reference": "Reference",
    "bank": "Bank",
    "dueDate": "Due date",
    "receipts": "Receipts it pays",
    "receiptsHint": "What is not given to a receipt stays as an advance on the supplier.",
    "receiptsAllHint": "A supplier that is not registered cannot hold an advance: the whole amount goes to the receipt.",
    "shareOldest": "Share over the oldest",
    "noOpenReceipts": "No receipt is waiting for a payment.",
    "openAmount": "{{amount}} open",
    "shareOf": "Amount for {{number}}",
    "allocated": "Given to receipts",
    "advance": "Advance on the supplier",
    "note": "Note",
    "proofs": "Proofs of payment",
    "addProof": "Add files",
    "proofsHint": "Receipts, transfer slips, cheque photos: PDF or images, sent with the payment.",
    "record": "Record the payment",
    "recorded": "Payment {{number}} recorded",
    "twinTitle": "{{number}} looks the same",
    "twinText": "A payment of this amount, by this method, on this day, is already recorded for this supplier.",
    "recordAnyway": "Record it anyway"
  },
  "allocate": {
    "title": "Share {{number}}",
    "description": "{{amount}} between the supplier's receipts.",
    "upTo": "up to {{amount}}",
    "over": "More than the payment",
    "saved": "Payment shared again"
  },
  "payment": {
    "payee": "Paid to",
    "pays": "Receipts it pays",
    "paysNothing": "No receipt: an advance on the supplier.",
    "unallocated": "{{amount}} of this payment is not allocated to a receipt yet.",
    "settledCredit": "recorded as {{name}}",
    "dueOn": "due {{date}}",
    "recordedBy": "Recorded by",
    "completedOn": "Paid on",
    "complete": "Mark as paid",
    "completeTitle": "Mark {{number}} as paid",
    "completeHint": "The day the cheque was cashed or the bill paid.",
    "completeCreditHint": "The day it was paid, and how it was paid.",
    "paidWith": "Paid with",
    "chooseMethod": "Choose a method",
    "completedToast": "Payment marked as paid",
    "allocate": "Share again",
    "cancel": "Cancel the payment",
    "cancelTitle": "Cancel {{number}}?",
    "cancelHint": "It stays in the list as cancelled and counts nowhere. A cheque that bounced, a bill not honoured, an entry made twice.",
    "cancelReason": "Why",
    "cancelledToast": "Payment cancelled",
    "cancelledBy": "Cancelled by {{name}}, {{date}}"
  },
  "payments": {
    "title": "Supplier payments",
    "subtitle": "Money paid to suppliers, and what is scheduled: cheques to cash, bills and credits to their due date.",
    "new": "New payment",
    "search": "Number, reference or supplier",
    "allStatuses": "All statuses",
    "allMethods": "All methods",
    "totalCompleted": "Paid:",
    "totalPending": "Scheduled:",
    "empty": "No payment found",
    "emptyText": "Payments are recorded from a supplier's page or a receipt.",
    "emptySupplier": "No payment to this supplier yet.",
    "advance": "Advance",
    "chooseSupplier": "Who is paid?",
    "continue": "Continue",
    "showing_one": "{{first}} to {{last}} of {{total}} payment",
    "showing_other": "{{first}} to {{last}} of {{total}}"
  }
}
